interface IBudgetVehicleAndClientCardsProps {
  vehicleData?: {
    model?: string;
    year?: string;
    licensePlate?: string;
    chassis?: string;
    odometer?: string;
    hourmeter?: string;
    contract?: string;
    inWarranty?: boolean;
  };
  clientData?: {
    name?: string;
    phone?: string;
    email?: string;
  };
}

const BudgetVehicleAndClientCards = (props: IBudgetVehicleAndClientCardsProps) => {
  const vehicle = props.vehicleData;
  const client = props.clientData;

  if (!vehicle && !client) {
    return null;
  }

  return (
    <div className="flex gap-4 mb-6 px-6 items-stretch">
      {vehicle && (
        <div className="flex-1 flex flex-col">
          <div className="font-bold bg-white p-2 rounded-t-lg">Veículo</div>
          <div className="bg-gray-200 rounded-b-lg p-4 relative flex-1">
            <div className="flex items-start gap-4">
              <div className="bg-white rounded p-4 flex-shrink-0 w-[55px] h-[70px] flex items-center justify-center mr-2">
                <img
                  src="/assets/images/truck.svg"
                  alt="Veículo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="flex-1">
                {(vehicle.model || vehicle.year || vehicle.licensePlate) && (
                  <div className="text-size-14 leading-tight">
                    {vehicle.model && <span className="font-bold">{vehicle.model}</span>}
                    {vehicle.year && ` ${vehicle.year}`}
                    {vehicle.licensePlate && ` | Placa: ${vehicle.licensePlate}`}
                  </div>
                )}
                {vehicle.chassis && (
                  <div className="text-size-14 leading-tight">Chassi - {vehicle.chassis}</div>
                )}
                {(vehicle.odometer || vehicle.hourmeter) && (
                  <div className="text-size-14 leading-tight">
                    {vehicle.odometer && `Odômetro: ${vehicle.odometer}`}
                    {vehicle.odometer && vehicle.hourmeter && ' | '}
                    {vehicle.hourmeter && `Horímetro: ${vehicle.hourmeter}`}
                  </div>
                )}
                {vehicle.contract && (
                  <div className="text-size-14 leading-tight">
                    Volks total Prev: Contrato #{vehicle.contract}
                  </div>
                )}
              </div>
            </div>
            {vehicle.inWarranty === true && (
              <div className="absolute top-4 right-4 mt-3 mr-3">
                <span className="px-3 py-1 rounded-full text-size-12 bg-green-500 text-white font-bold">
                  Em garantia
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {client && (
        <div className="flex-1 flex flex-col">
          <div className="font-bold bg-white p-2 rounded-t-lg">Cliente</div>
          <div className="bg-white border border-gray-300 rounded-b-lg p-4 flex-1">
            {client.name && <div className="text-size-14 mb-1">{client.name}</div>}
            {client.phone && <div className="text-size-14 mb-1">{client.phone}</div>}
            {client.email && <div className="text-size-14 text-right">{client.email}</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default BudgetVehicleAndClientCards;
